export default __webpack_public_path__ + "static/media/labels.2bfe7f14.svg";